import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const AuthTypeSeparator = ({ className, label }) => {
  const styles = useStyles();

  return (
    <CustomTypography
      className={cx(className, styles.oauthLabel)}
      variant={TYPOGRAPHY_VARIANT.regular14}
    >
      {label || 'OR'}
    </CustomTypography>
  );
};

AuthTypeSeparator.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

AuthTypeSeparator.defaultProps = {
  className: null,
  label: null,
};
